<script lang="ts">
    import { flip } from "svelte/animate";
    import { AssetGenerationProgress } from "../../model";
    import { Slot, SLOT_TYPES } from "../../model/Slot";
    import LoadingSpinner from "./LoadingSpinner.svelte";
    import BootstrapVectorIcon from "./BootstrapVectorIcon.svelte";
    import Asset3DViewer from "./Asset3DViewer.svelte";
    
    interface Props {
        assetId: string;
        assetUrl?: string;
        /**
     * Only set job if this is in the progress of being loaded
     */
        job?: AssetGenerationProgress;
        /**
     * The column width for this card
     */
        cardGridCols?: number;
        /**
     * The slot referenced for this card
     */
        slot: Slot;
        /**
     * Enable or disable display of checkmark
     */
        showCheckMark?: boolean;
        /**
     * A callback for when the checkmrk is clicked
     */
        keepImageCheckboxCallback: (assetId: string) => void;
        /**
     * The indicator for whether the checkmark is clicked
     */
        checked?: boolean;
    }

    let {
        assetId,
        assetUrl = undefined,
        job = undefined,
        cardGridCols = 3,
        slot,
        showCheckMark = true,
        keepImageCheckboxCallback,
        checked = false,
    }: Props = $props();


    function keepImageCheckboxClicked(event: Event): boolean {
        event.preventDefault();
        keepImageCheckboxCallback(assetId)
        return false;
    }
</script>

<div class="col-12 col-xl-{cardGridCols} px-2">
    <div class="card" data-assetId={assetId}>
        <div
            class="img-placeholder-block"
            style="padding-top: {slot.type == SLOT_TYPES.TEXTURE ? (slot.dimensions[1] * 100) /
                slot.dimensions[0] : "0" }%;"
        >
            {#if assetUrl || job.assetUrl}
                {#if slot.type == SLOT_TYPES.TEXTURE}
                    <img
                        src={assetUrl || job.assetUrl}
                        class="figure-img"
                        alt="..."
                    />
                {:else if slot.type == SLOT_TYPES.OBJECT_3D}
                    <Asset3DViewer url={assetUrl}></Asset3DViewer>
                {:else}
                    <i>Unsupported Asset Type</i>
                {/if}
            {:else if assetUrl || job.error}
                <div class="position-absolute top-50 start-50 translate-middle">
                    <BootstrapVectorIcon class="text-danger" icon="x" style="width: 2em; height: 2em;"></BootstrapVectorIcon> Error: {job.error}
                </div>
            {:else}
                <div class="position-absolute top-50 start-50 translate-middle">
                    <LoadingSpinner
                        style="height: 4em; width: 4em;"
                        loaded={false}
                    ></LoadingSpinner>
                </div>
            {/if}
        </div>

        {#if (assetUrl || job.assetUrl) && showCheckMark}
            <button
                class="btn position-absolute top-0 end-0"
                style="width: auto"
                onclick={keepImageCheckboxClicked}
            >
                <BootstrapVectorIcon
                    icon={checked ? "check-square" : "square"}
                    class="text-light"
                    style="width: 2em; height: 2em;"
                ></BootstrapVectorIcon>
            </button>
        {/if}

        <div class="card-body d-none">
            {#if job && !job.assetUrl}
                <div class="progress" style="position: relative;">
                    <div
                        class="progress-bar"
                        role="progressbar"
                        style="width: {Math.floor(
                            job.getProgressPercent() * 100,
                        )}%;
                                                                        transition: width 2s;
                                                                        "
                        aria-valuenow={Math.floor(job.progress)}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                    <div
                        class="text-center"
                        style="position: absolute; width: 100%; height: 100%;"
                    >
                        {Math.floor(job.getProgressPercent() * 100) + " %"}
                    </div>
                </div>
            {/if}
        </div>
    </div>
</div>
